import React from 'react';
import { Modal } from 'react-responsive-modal';
import ReactPlayer from 'react-player';
import 'react-responsive-modal/styles.css';

export default function ModalVideo({
  isOpen,
  onClose,
  channel = 'youtube',
  videoId,
  url,      
  autoplay = true,
}) {
  const src =
    channel === 'youtube'
      ? `https://www.youtube.com/watch?v=${videoId}`
      : channel === 'vimeo'
      ? `https://vimeo.com/${videoId}`
      : url;

  return (
    <Modal open={isOpen} onClose={onClose} center styles={{ modal: { padding: 0, background: 'transparent' } }}>
      <div style={{ width: '80vw', maxWidth: 900 }}>
        <div style={{ position: 'relative', paddingTop: '56.25%' }}>
          <ReactPlayer
            url={src}
            playing={autoplay}
            controls
            width="100%"
            height="100%"
            style={{ position: 'absolute', top: 0, left: 0 }}
          />
        </div>
      </div>
    </Modal>
  );
}
